import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  TextField,
  Button,
  Typography,
  Divider,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../../context/AuthContext';

const LoginModal = () => {
  const { showLoginModal, closeModals, openRegisterModal, login } = useAuth();
  const [formData, setFormData] = useState({ Email: '', Password: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.Email || !formData.Password) {
      return;
    }
    setLoading(true);
    await login(formData);
    setLoading(false);
    setFormData({ Email: '', Password: '' });
  };

  const handleSwitchToRegister = () => {
    setFormData({ Email: '', Password: '' });
    openRegisterModal();
  };

  return (
    <Dialog
      open={showLoginModal}
      onClose={closeModals}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3 }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
        <Typography variant="h5" fontWeight="bold" color="#5D4037">
          Welcome Back
        </Typography>
        <IconButton onClick={closeModals} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Email Address"
            name="Email"
            type="email"
            value={formData.Email}
            onChange={handleChange}
            required
            sx={{ mb: 2 }}
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Password"
            name="Password"
            type="password"
            value={formData.Password}
            onChange={handleChange}
            required
            sx={{ mb: 3 }}
            variant="outlined"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loading}
            sx={{
              py: 1.5,
              bgcolor: '#8B4513',
              '&:hover': { bgcolor: '#6d3610' },
              fontWeight: 'bold',
              fontSize: '1rem',
              borderRadius: 2,
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
          <Box sx={{ textAlign: 'center', mt: 3 }}>
            <Typography variant="body2" color="text.secondary">
              Don't have an account?{' '}
              <Button
                onClick={handleSwitchToRegister}
                sx={{ textTransform: 'none', color: '#8B4513', fontWeight: 'bold' }}
              >
                Create Account
              </Button>
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoginModal;
